

























import Vue from 'vue'

import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import AppDialog from '@/components/AppDialog.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppTableDate from '@/components/AppTableDate.vue'
import { Account } from '@/modules/Account/interfaces/account'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'

@Component({
  components: {
    AppDialog,
    AppBreadcrumbs,
    AppTableDate
  }
})
export default class PoliciesDialog extends Vue {
  @Prop({ type: Boolean }) readonly show!: boolean
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: Array }) readonly accounts!: Account[]

  showDialog = false

  accountTableColumn = [
    {
      field: 'name',
      title: 'Account Name',
      slots: { default: 'name_default' },
      sortable: true,
      resizable: true
    },
    { title: 'Phone',
      field: 'phone',
      slots: { default: 'phone_default' },
      resizable: true,
      sortable: true
    },
    {
      title: 'Producer',
      field: 'producers',
      slots: {
        default: 'producers_default'
      },
      resizable: true,
      sortable: true
    }
  ]

  formatPhoneNumber = formatPhoneNumber

  filteredAccounts: Account[] = []

  get accountsPerPage () {
    const { tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const offset = (currentPage - 1) * pageSize
    return this.$R.slice(offset, pageSize + offset, this.filteredAccounts)
  }

  @Watch('show')
  async onShowChanged (val: boolean) {
    this.showDialog = val
  }

  @Watch('accounts')
  onPoliciesChanged (val: Account[]) {
    this.tableOptions.loading = false
    this.tableOptions.tablePage.total = val.length
    this.tableOptions.tablePage.currentPage = 1
    this.filteredAccounts = val
  }

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.filterAccounts()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
  }

  filterAccounts () {
    const { filterAccounts } = this
    const { sortBy, sortDesc } = this.tableOptions

    this.filteredAccounts = sortDesc
      ? this.$R.sortWith([this.$R.descend(this.$R.prop(sortBy))])(filterAccounts)
      : this.$R.sortWith([this.$R.ascend(this.$R.prop(sortBy))])(filterAccounts)

    this.tableOptions.tablePage.total = this.filteredAccounts.length
  }

  @Emit('cancel')
  handleCancel () {
    // do nothing
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  routeToDetail (item: any) {
    this.routeTo('AccountDetailDetail', {
      id: item.id
    })
  }
}
